import React, { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import _get from 'lodash/get';
import { withKeyboardAccessibility } from 'reaxl/lib/Utilities/AccessibilityUtilities';

import { useDevice } from '@bonnet/next/device';

import { eventBus } from '@atc/cai-event-bus';

import { Glyphicon, StickyContainer, StickyElement, StickyTrigger, Text } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { psxVDPChatSellerClick } from 'reaxl-analytics-handlers';

import authDuck from '@/ducks/authDuck.js';
import userDuck from '@/ducks/userDuck.js';
import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

const BOTTOM_OFFSET = 10;
function PsxBubbleChat() {
    const [bubbleChatOffsetBottom, setBubleChatOffsetBottom] = useState(0);
    const memorizedOffsetBottomMobile = useRef(BOTTOM_OFFSET);

    const isWebComponentReady = useSelector(vdpResultsDuck.selectors.getIsWebComponentReady);
    const { id: inventoryId } = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);
    const isHasChatPreviouslyVdpListing = useSelector((currentState) => userDuck?.selectors?.isHasChatPreviouslyVdpListing(currentState, inventoryId)) || false;
    const isLoggedIn = useSelector(authDuck.selectors.isLoggedIn);
    const dispatch = useDispatch();

    const device = useDevice();
    const isXs = _get(device, 'is.xs', false);

    useEffect(() => {
        if (!isXs) {
            setBubleChatOffsetBottom(BOTTOM_OFFSET);
        } else {
            setBubleChatOffsetBottom(memorizedOffsetBottomMobile.current);
        }
    }, [isXs, setBubleChatOffsetBottom]);

    const handleChangeBubbleChatPosition = (position) => {
        // Set offset bottom with desired position when in mobile view
        memorizedOffsetBottomMobile.current = position;
        if (isXs) {
            setBubleChatOffsetBottom(memorizedOffsetBottomMobile.current);
        }
    };

    const handleChatClick = (event) => {
        eventBus.emit('psx.listingActions.openChat', {});

        if (!isHasChatPreviouslyVdpListing && isLoggedIn) {
            sendClick(psxVDPChatSellerClick, event, { inventoryId });
            dispatch(userDuck.creators.updateHasChatPreviouslyVdpListings(inventoryId));
        }
    };

    return (
        <StickyContainer>
            <StickyTrigger
                onEnter={() => handleChangeBubbleChatPosition(BOTTOM_OFFSET)}
                onLeave={() => handleChangeBubbleChatPosition(75)}
            />
            <StickyElement
                position="bottom"
                hasBoxShadow={false}
                remainSticky={isWebComponentReady}
                isAnimated={false}
                offset={{
                    left: 10,
                    bottom: bubbleChatOffsetBottom,
                }}
            >
                <button
                    className="text-inverse bg-accent btn display-flex flex-column align-items-center justify-content-center"
                    type="button"
                    style={{
                        borderRadius: '50%',
                        width: '80px',
                        height: '80px',
                    }}
                    onClick={handleChatClick}
                    onKeyDown={withKeyboardAccessibility(handleChatClick)}
                >
                    <Glyphicon
                        glyph="commenting-o"
                        aria-hidden="true"
                        className="text-size-700"
                    />
                    <Text
                        size={300}
                        weight="normal"
                    >
                        Chat
                    </Text>
                </button>
            </StickyElement>
        </StickyContainer>
    );
}

export default PsxBubbleChat;
